export default __webpack_public_path__ + "static/media/closeBtn.36a60434.svg";